import { render, staticRenderFns } from "./PerformancePlatformsSelect.vue?vue&type=template&id=bd6ed46c&scoped=true"
import script from "./PerformancePlatformsSelect.vue?vue&type=script&lang=js"
export * from "./PerformancePlatformsSelect.vue?vue&type=script&lang=js"
import style0 from "./PerformancePlatformsSelect.vue?vue&type=style&index=0&id=bd6ed46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6ed46c",
  null
  
)

export default component.exports